import React, { FC } from "react";
import { PaneDimensionsProvider } from "./PaneDimensionsProvider";
import { PaneSizeProvider } from "./PaneSizeProvider";

export interface PaneDimensionsAndSizeProviderProps {
  width: number | undefined;
  height: number | undefined;
  children: React.ReactNode;
}

export const PaneDimensionsAndSizeProvider: FC<
  PaneDimensionsAndSizeProviderProps
> = (props) => {
  return (
    <PaneDimensionsProvider width={props.width} height={props.height}>
      <PaneSizeProvider width={props.width} height={props.height}>
        {props.children}
      </PaneSizeProvider>
    </PaneDimensionsProvider>
  );
};
